// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import App from '@/app'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify, { theme: {
  primary: '#009ee2',
  secondary: '#4e4e4e',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}})
Vue.use(VeeValidate, { inject: false })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#licence',
  components: { App }
})
new Vue({
  el: '#mooring',
  components: { App }
})
new Vue({
  el: '#vessel',
  components: { App }
})
new Vue({
  el: '#calculator',
  components: { App }
})
new Vue({
  el: '#mooring-fees',
  components: { App }
})
new Vue({
  el: '#recreational-fees',
  components: { App }
})
new Vue({
  el: '#boating-licence-fees',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js